<template>
  <conditional-section :active="active">
    <div class="mx-1">
      <growth-chart
        v-if="!!growthValues[growthType] && growthValues[growthType] != []"
        primary
        :data="growthValues[growthType]"
        :percentage="growthTypeIsPercentage"
        :title="`${collectionName} Growth`"
        :value-name="`New ${(collectionName.indexOf('.csv') > -1) ? '' : collectionName}`"
        :value-title="growthTitles.value"
        :aggregation-name="`Cumulative ${(collectionName.indexOf('.csv') > -1) ? '' : collectionName}`"
        :aggregation-title="growthTitles.aggregation"/>
    </div>

    <masonry :key="insightComputationKey">
      <date-insight
        v-for="dateInsight in dateInsights"
        :key="`${dateInsight['slug']}-date`"
        :values="dateInsight['data']"
        :name="dateInsight['name']"
        v-bind="dateInsight"
        :data-file-type="dataFileType"/>
      
      <!-- <categorical-insight
        v-for="dateInsight in dateInsights"
        :key="dateInsight['slug']"
        v-bind="dateInsight"
        :title="`${dataType}`"/> -->

      <categorical-insight
        v-for="counts in categoricalValueCounts"
        :key="counts['slug']"
        v-bind="counts"
        :title="`${dataType}`"/>

      <single-value-insights
        :values="categoricalSingleValuedData"/>
    </masonry>
  </conditional-section>
</template>

<script>
  import SingleValueInsights from './SingleValueInsights';
  import GrowthChart from './GrowthChart';
  import CategoricalInsight from './CategoricalInsight';
  import {fetchInsight} from './utils';
  import CategoricalInsightMixin from './CategoricalInsightsMixin';
  import InsightsComputationMixin from './InsightsComputationMixin';
  import DateInsightsMixin from './DateInsightsMixin';
  import DateInsight from './DateInsight';
  import Masonry from './Masonry';
  import ConditionalSection from './ConditionalSection';

  const defaultGrowthValues = () => ({
    count: null,
    amount: null,
    average: null
  });

  export default {
    name: 'SecondaryDataTab',

    mixins: [
      CategoricalInsightMixin,
      InsightsComputationMixin,
      DateInsightsMixin
    ],

    props: {
      active: Boolean,
      rawFile: Object,
      dataType: String,
      database: String,
      filter: Object | String
    },

    components: {
      Masonry,
      CategoricalInsight,
      GrowthChart,
      SingleValueInsights,
      DateInsight,
      ConditionalSection
    },

    watch: {
      growthType() {
        this.computeGrowthInsight();
      }
    },

    data() {
      // window.dispatchEvent(new Event('resize'));
      return {
        collectionName: this.dataType.indexOf('.csv') > -1 ? this.rawFile['name'] : this.dataType,
        growthTypeKey: 'count',
        growthValues: defaultGrowthValues()
      };
    },

    methods: {
      computeGrowthInsight() {
        const aggregation = this.growthType;
        if (this.growthValues[aggregation]) return;
        
        fetchInsight(
          `Growth`,
          {...this.filter, database: this.database, collection: this.dataType},
          {aggregation}
          )
          .then(data => {
            console.log('Growth: ', data, this.growthType);
            this.growthValues[aggregation] = data;
          });
      },

      resetInsightsData() {
        this.growthValues = defaultGrowthValues();
        this.resetCategoricalData();
        this.resetDateInsights();
      },

      computeInsightsData() {
        // this.fetchCategoricalData(this.filter);
        // this.fetchDateInsights(this.filter);
        this.fetchSegmentCategoricalData(this.filter);
        this.fetchSegmentDateInsights(this.filter);
        this.computeGrowthInsight();
      },
    },

    computed: {
      dataFileType() {
        return this.dataType;
      },

      growthTypeOptions() {
        return [
          {value: 'count', text: 'Total Count'},
          {value: 'amount', text: 'Total Amount'},
          {value: 'average', text: 'Average Amount'},
          {value: 'percent_count', text: 'Count %'},
          {value: 'percent_amount', text: 'Amount %'},
        ];
      },

      growthType() {
        if (this.growthTypeIsPercentage) {
          return this.growthTypeKey.substr('percent_'.length);
        }
        return this.growthTypeKey;
      },

      growthTypeIsPercentage() {
        return this.growthTypeKey.startsWith('percent_');
      },

      growthTitles() {
        const suffix = this.growthTypeIsPercentage ? ' (%)' : '';
        const name = ((growthType) => {
          switch (growthType) {
            case 'average':
              return 'Average Amount';
            case 'amount':
              return 'Amount';
            default:
              return 'Count';
          }
        })(this.growthType);

        return {
          value: `New ${this.collectionName} ${name} ${suffix}`,
          aggregation: `Total ${this.collectionName} ${name} ${suffix}`
        };
      }
    }
  };
</script>
